import * as React from 'react';
import { SVGProps } from 'react';
const SvgComponent = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" width={24} height={24} viewBox="0 0 24 24" fill="none" {...props}>
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={2}
      d="M20.728 4.705a5.429 5.429 0 0 0-7.681 0L12 5.752l-1.046-1.047a5.431 5.431 0 1 0-7.682 7.681l1.047 1.047L12 21.114l7.681-7.68 1.047-1.047a5.43 5.43 0 0 0 0-7.682Z"
    />
  </svg>
);
export { SvgComponent as Heart };
